import {
  LayoutDashboard, CalendarRange, ClipboardCheck, ClipboardList, BarChart3, Users, FileText, FileBadge2,
  Banknote, AlertTriangle, Settings, Mail, CalendarDays, MapPin, UserRound, CalendarClock, Wallet, Fingerprint,
  ScrollText, Plane,
} from "lucide-react";

/**
 * Sidebar structure per role. An item with `children` renders as an expandable
 * group (admin-panel style); its `id` keys the expanded state.
 */
export const NAV = {
  admin: [
    { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
    {
      id: "people", label: "People", icon: Users, children: [
        { to: "/employees", label: "Employees", icon: Users },
        { to: "/document-expiry", label: "Document Expiry", icon: AlertTriangle },
      ],
    },
    {
      id: "leave", label: "Leave", icon: Plane, children: [
        { to: "/leave/approvals", label: "Approvals", icon: ClipboardCheck },
        { to: "/leave/configuration", label: "Configuration", icon: ClipboardList },
        { to: "/holidays", label: "Holiday Calendar", icon: CalendarDays },
      ],
    },
    { to: "/attendance", label: "Attendance", icon: MapPin },
    {
      id: "payroll", label: "Payroll", icon: Wallet, children: [
        { to: "/payroll/wps", label: "WPS Payroll", icon: Banknote },
        { to: "/payroll/slips", label: "Salary Slips", icon: FileText },
        { to: "/payroll/certificates", label: "Salary Certificates", icon: FileBadge2 },
      ],
    },
    {
      id: "insights", label: "Insights", icon: BarChart3, children: [
        { to: "/reports", label: "Reports", icon: BarChart3 },
        { to: "/notifications", label: "Email Notifications", icon: Mail },
      ],
    },
    { to: "/settings", label: "Settings", icon: Settings },
  ],
  manager: [
    { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
    { to: "/employees", label: "My Team", icon: Users },
    {
      id: "leave", label: "Leave", icon: Plane, children: [
        { to: "/leave/approvals", label: "Team Approvals", icon: ClipboardCheck },
        { to: "/holidays", label: "Holiday Calendar", icon: CalendarDays },
      ],
    },
    { to: "/attendance", label: "Team Attendance", icon: MapPin },
    { to: "/notifications", label: "Notifications", icon: Mail },
    { to: "/settings", label: "Settings", icon: Settings },
  ],
  employee: [
    { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
    {
      id: "attendance", label: "Attendance", icon: CalendarClock, children: [
        { to: "/attendance/punch", label: "Punch In / Out", icon: Fingerprint },
        { to: "/attendance/history", label: "History", icon: CalendarRange },
      ],
    },
    {
      id: "leave", label: "Leave", icon: Plane, children: [
        { to: "/leave/apply", label: "Apply Leave", icon: ClipboardList },
        { to: "/leave/history", label: "My Leaves", icon: ClipboardCheck },
        { to: "/leave/balance", label: "Leave Balance", icon: BarChart3 },
        { to: "/holidays", label: "Holidays", icon: CalendarDays },
      ],
    },
    {
      id: "payroll", label: "Payroll", icon: Wallet, children: [
        { to: "/payroll/slips", label: "My Salary Slips", icon: ScrollText },
        { to: "/payroll/certificates", label: "Salary Certificates", icon: FileBadge2 },
      ],
    },
    { to: "/profile", label: "My Profile", icon: UserRound },
    { to: "/settings", label: "Settings", icon: Settings },
  ],
};

// Pages that aren't in the sidebar still need a header title.
const EXTRA_TITLES = [
  [/^\/payroll\/slips\/generate/, "Generate Salary Slip"],
  [/^\/employees\/.+/, "Employee Profile"],
];

const flatten = (items) => items.flatMap((i) => (i.children ? i.children : [i]));

/** Longest nav path that prefixes `pathname` — the active leaf. */
export function activeLeaf(items, pathname) {
  return flatten(items)
    .filter((l) => pathname === l.to || pathname.startsWith(`${l.to}/`))
    .sort((a, b) => b.to.length - a.to.length)[0];
}

export function pageTitle(items, pathname) {
  const extra = EXTRA_TITLES.find(([re]) => re.test(pathname));
  if (extra) return extra[1];
  return activeLeaf(items, pathname)?.label || "MediLearn HRMS";
}
